import { Button, Grid, Typography } from '@mui/material'
import dayjs from 'dayjs'
import { useEffect } from 'react'
import { AppContextProps, useAppContext } from '../../../../libs/app-core/AppContext'
import { MemberDAO } from '../../../dao/MemberDAO'
import { UniAnswer } from '../../../dao/UniAnswer'
import { UniAnswerDAO } from '../../../dao/UniAnswerDAO'
import { new_ErrorAlert } from '../../../export_spwk/ExportManager'
import { useGV } from '../../../GV'
import AuthHelper from '../../../heplers/AuthHelper'
import { NavigateTo_FrmMemberTodo_Async } from '../../FrmProjectEditor'
import { ROUTE_member_todo } from '../../../Routes'

type Props = {
  _UniAnswer: UniAnswer | null | undefined,
}

const UcFinishedPage = ({ _UniAnswer }: Props) => {
  const GV = useGV();
  const ctx = useAppContext();

  useEffect(() => {
    async function async_fn() {
      try {
        if (_UniAnswer == null) {
          return
        }
        const member = await MemberDAO.WS_FetchByGuid(_UniAnswer?.member_guid);
        if (dayjs(member.spwk_done_at).year() === 2999) {
          await MemberDAO.WS_Update_標記為完成特作(member);
        }

        if (dayjs(_UniAnswer.rec_dt).year() === 2999) {
          await UniAnswerDAO.WS_Update_完成問卷時間(_UniAnswer);
        }
        if (GV.IsAdmin()) {
        } else {
          ctx.Navigate(ROUTE_member_todo.url + "?member_guid=" + _UniAnswer?.member_guid);
        }
      } catch (ex: any) {
        console.log("錯誤! 無法標記特作完成!" + ex.message);
        throw new_ErrorAlert("錯誤! 無法標記特作完成!");
      }
    }
    async_fn();
  }, [])

  function btn_Logout_Click() {
    const IsNewVersion = true
    if (IsNewVersion) {
      //#region 新版本: 多頁 返回主選單
      if (_UniAnswer == null) {
        throw new_ErrorAlert('7434579  _UniAnswer=null')
      }
      window.history.back();
      //#endregion
    } else if ((IsNewVersion === false)) {
      //#region 舊版本: 單頁特作時: 登出
      if (GV == null) {
        throw new_ErrorAlert("ERROR! GV==null !!!");
      }

      AuthHelper.Logout(GV, ctx);
      //#endregion
    } else {
      throw new_ErrorAlert('7469813+ 請確認IsNewVersion')
    }


  }

  return (
    <Grid
      item
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
    >
      <Typography variant="h3" gutterBottom sx={{ textAlign: 'center' }}>表單已填寫完成!</Typography>
      <Button variant="contained" size="large" onClick={btn_Logout_Click}>
        <Typography variant="h3">返回待作問卷列表</Typography>
      </Button>
    </Grid>
  )
}
export async function BackToTodo(ctx: AppContextProps, member_guid: string) {
  await NavigateTo_FrmMemberTodo_Async(ctx, member_guid);
}
export default UcFinishedPage